{
  "schemaVersion": 1,
  "assets": {
    "menuButtons": {
      "path": "/game/ui/tools/menu-buttons.jpg",
      "width": 385,
      "height": 48,
      "sourcePath": "assets/reference/official/images/2009_28-3711_reference_06.jpg",
      "sourceSha256": "c885aa83ae9a68e090a8bdc8bb5f653c1c4b303513acf675488e0b16d1e8f2c4",
      "sha256": "c885aa83ae9a68e090a8bdc8bb5f653c1c4b303513acf675488e0b16d1e8f2c4",
      "derivation": "Unmodified original screenshot strip; runtime clipping preserves the existing round button artwork.",
      "candidateConfidence": "Dated 2009 official game-toolbar reference. Reused menu icons are adapted to the current actions, without claiming these were their exact historical positions or mappings.",
      "buttons": {
        "info": {
          "x": 49,
          "y": 1,
          "width": 46,
          "height": 46
        },
        "help": {
          "x": 146,
          "y": 1,
          "width": 46,
          "height": 46
        },
        "invite": {
          "x": 194,
          "y": 1,
          "width": 46,
          "height": 46
        },
        "sound": {
          "x": 241,
          "y": 1,
          "width": 46,
          "height": 46
        },
        "back": {
          "x": 339,
          "y": 1,
          "width": 46,
          "height": 46
        }
      },
      "originalUrl": "http://img.my4399.com/uploads/userup/0904/2R02Ra621.jpg",
      "pageUrl": "https://web.4399.com/ddt/youxiziliao/200904/28-3711.html",
      "publishedDate": "2009-04-28",
      "versionEvidence": "官方旧版资料页与图片路径/0904/，日期一致"
    }
  }
}
